import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Col, Container, Row } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import LeftSidebarProfile from './LeftSidebarProfile';
import ProfileTab from './ProfileTab';

const Profile = props => {
    return (
        <React.Fragment>
            <div className="page-content">
                <Helmet>
                    <title>Profile Page | Samply - React Admin & Dashboard Template</title>
                </Helmet>
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Pages" breadcrumbItem="Profile" />

                    <Row className="mb-4">
                        <Col xl={4}>
                            <LeftSidebarProfile />
                        </Col>
                        <Col xl={8}>
                            <ProfileTab />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default Profile;